import { ApiResponse } from "@/utils/ApiResponse";
import apiClient from "@/clients/apiClient";
import { MarcaVehiculoInterface } from "../../interfaces/marcaVehiculosInterfaces/MarcaVehiculo.interface";

export async function ListMarcaModeloVehiculoAction(): Promise<
  ApiResponse<MarcaVehiculoInterface>
> {
  const { data } = await apiClient.get<MarcaVehiculoInterface>(
    "/gvMarcaVehiculos/MarcaModelo"
  );
  return {
    status: 200,
    data,
    message: "Marca de vehiculos obtenidas correctamente",
  };
}
